import React from 'react';

import AuthProvider from '../auth/AuthProvider';
import Layout from '../components/Layout';
import Seo from '../components/Seo';
import Homepage from '../containers/Homepage';
import Hero from '../containers/Homepage/Hero';
import SimpleFooter from '../containers/Homepage/SimpleFooter';

const IndexPage = () => (
  <AuthProvider>
    <Layout isHomepage pathname="/">
      <Seo meta={[{ name: 'og:image', content: '/og/hero.jpg' }]} />
      <Homepage>
        <Hero />
        <SimpleFooter />
      </Homepage>
    </Layout>
  </AuthProvider>
);

export default IndexPage;
